module.exports = __webpack_public_path__ + "img/dstv.50e2e90f.png";